const facebookAccountData = [
  {
    name: "NOT A REAL AD ACCOUNT",
    adspixels: {
      data: [{ id: "1495489613890333", name: " Pixel 1" }],
      paging: {
        cursors: {
          before: "MTQ5NTQ4OTYxMzg5MDMzMwZDZD",
          after: "MTQ5NTQ4OTYxMzg5MDMzMwZDZD",
        },
      },
    },
    account_id: "41890927",
    id: "act_41890927",
  },
  {
    name: "Not a real Ad Account",
    adspixels: {
      data: [
        { id: "549574391841010" },
        { id: "1023988524406057", name: "Main pixel" },
        { id: "2569999219948026", name: "2nd pixel" },
        { id: "384569272301733", name: "3rd pixel" },
      ],
      paging: {
        cursors: {
          before: "NTQ5NTc0MzkxODQxMDEw",
          after: "Mzg0NTY5MjcyMzAxNzMz",
        },
      },
    },
    account_id: "1086799141482084",
    id: "act_1086799141482084",
  },
  {
    name: "Not a real Ad Account - W/O Pixels",
    account_id: "1086799141482084",
    id: "act_1086799141482084",
  },
];

module.exports = facebookAccountData;
